import { Button, InputAdornment, Stack, TextField } from "@mui/material";
import type { ChangeEvent } from "react";
import { useState } from "react";
import { accessCheckButtonSx, accessCheckFieldSx } from "./styles";

const codeLength = 6;
const isValidCode = (value: string): boolean => /^\d{6}$/.test(value);

interface Props {
  errorText?: string;
  submitting: boolean;
  resending: boolean;
  onSubmit: (code: string) => void;
  onResend: () => void;
}

const VerifyCodeForm = ({ errorText, submitting, resending, onSubmit, onResend }: Props) => {
  const [code, setCode] = useState("");
  const codeReady = isValidCode(code);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const next = event.target.value.replace(/\D/g, "").slice(0, codeLength);
    setCode(next);
  };

  const handleVerifyClick = () => {
    if (codeReady && !submitting) {
      onSubmit(code);
    }
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <TextField
        label="Verification code"
        value={code}
        onChange={handleChange}
        error={Boolean(errorText)}
        helperText={errorText}
        autoFocus
        fullWidth
        sx={accessCheckFieldSx}
        slotProps={{
          htmlInput: { inputMode: "numeric", pattern: "\\d*", maxLength: codeLength },
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Button variant="text" color="primary" onClick={onResend} loading={resending} disabled={submitting}>
                  Send new code
                </Button>
              </InputAdornment>
            ),
          },
        }}
      />
      <Button
        variant="contained"
        color="primary"
        disabled={!codeReady}
        loading={submitting}
        onClick={handleVerifyClick}
        fullWidth
        sx={accessCheckButtonSx}
      >
        Verify & Continue
      </Button>
    </Stack>
  );
};

export default VerifyCodeForm;
